import gql from 'graphql-tag'

export const fetchProductsSearchQuery = gql(`
  query (
    $search: String
    $currentPage: Int!
    $pageSize: Int = 5
    $material_type: String
  ) {
    products(
      search: $search
      filter: {
       material_type:{ eq: $material_type}
      }
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      items {
        sku
        volume_fe
        your_price_tax
        volume
        catalog_product_name
        name
        filter_packaging
        product_last
        product_new
        product_sale
        product_recommended
        product_special
        small_image {
          url
        }
        ... on BundleProduct {
          bundle_price_sum_tax
        }
      }
    }
  }
`)
